namespace advisorop.components.servicer {

    export class OfficeRangeListController {

        dg: DevExpress.ui.dxDataGridOptions;

        showAddModifyPanel: boolean = false;

        //this version of custodianCompanyGroup contains officeRanges
        custodianAdvisoryFirm: domains.ICustodianAdvisoryFirm = {
            officeRanges: []
        };

        custodians: domains.ICustodianAdvisoryFirm[];
        
        editedOfficeRange: domains.ICustodianAdvisoryFirmOfficeRange = {};
        
        selCustodian: domains.ICustodianAdvisoryFirm;
        
        constructor(private servicerService: services.ServicerService) {

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "OfficeRanges"
                },
                bindingOptions: {
                    dataSource: "vm.custodianAdvisoryFirm.officeRanges"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                //height: "350px",
                paging: { pageSize: 5 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,                
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: "Search..."
                },                
                columns: [
                    { dataField: "description", caption: "Description" },
                    { dataField: "code", caption: "Code", width: 120},                      
                    { dataField: "id", caption: "#", cellTemplate: "btnActions", width: 130 }
                    
                ]                
            };
        }  

        custodianChanged(): void {
            if (this.selCustodian) {
                //load office range for new custodian
                this.servicerService.getCustodianAdvisoryFirm(this.selCustodian.id)
                    .then(data => {
                        this.custodianAdvisoryFirm = data.data;
                    })
                    .catch(data => {
                        toastr.error("Error " + data.status + " " + data.data);
                    });
            }
            //else
            //    this.custodian = {
            //        officeRanges: []
            //    };
        }

        newOfficeRange(): void {
            this.editedOfficeRange = {
                id: 0
            };
            this.showAddModifyPanel = true;
        };

        editOfficeRange(officeRange: domains.ICustodianAdvisoryFirmOfficeRange) {

            this.editedOfficeRange = {};

            angular.copy(officeRange, this.editedOfficeRange); 
           
            this.showAddModifyPanel = true;
        };

        cancel(): void {
            this.editedOfficeRange = {};
            this.showAddModifyPanel = false;
        };


        // /////////////////////////////////
        // Event handling ...
        officeRangeCreated(officeRange): void {

            toastr.info("New custodian office range / master account has been successfully created");

            var newOfficeRange = {};

            angular.copy(officeRange, newOfficeRange);

            this.custodianAdvisoryFirm.officeRanges.push(newOfficeRange);

            this.cancel();
            
        };

        officeRangeModified(officeRange): void {

            if (!officeRange)
                return;

            var ind = this.custodianAdvisoryFirm.officeRanges.map(m => { return m.id; }).indexOf(officeRange.id);

            if (ind >= 0) {
                this.custodianAdvisoryFirm.officeRanges[ind] = officeRange;
            }

            toastr.info("Custodian office range / master account has been successfully modified");

            //this.loadOfficeRanges();

            this.cancel();
        };
        
        
        $onInit(): void {
            //this.loadOfficeRanges();
        }

        $onChanges(evt): void {
            //{ currentValue, previousValue, isFirstChange() }            
            for (var key in evt) {                
            }
        }
        
    }
    
    class OfficeRangeList implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                custodians: "<"
            };
            this.controller = ["servicerService", OfficeRangeListController];
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/office-range-list.html";
        }
    }
    angular.module(Constants.APP).component("officeRangeList", new OfficeRangeList());

}